// extracted by mini-css-extract-plugin
export var contentBody = "_dn-9";
export var headerImage = "_dn-2";
export var imageButton = "_dn-7";
export var imageButtonIcon = "_dn-8";
export var imageHeader = "_dn-4";
export var imageHeaderText = "_dn-5";
export var imageOverlay = "_dn-3";
export var imageTitle = "_dn-6";
export var imageWrapper = "_dn-1";
export var taskList = "_dn-a";
export var widget = "_dn-0";